// extracted by mini-css-extract-plugin
export default {"root":"style_root__D5mIL","page":"style_page__Dw4Sp"};